// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-page {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 32px;
    align-items: stretch; 
    padding: 20px;
    min-height: 80vh;
}

.contact-card {
  display: flex;
  /* align-items: stretch;  */
  flex-direction: column;
  justify-content: space-between;
  height: 80%;
  width: 80%;
  margin: 100px auto 0 auto;              
  /* padding: px 24px 24px;     */
  position: relative;
  background-color: #f9f9f9;
  border-radius: 8px;
  text-align: left;
}

.avatar-wrapper {
    position: absolute; 
    top: -60px;
    left: 0px;
    /* width: 200px;
    height: 200px; */
    width: 13vw;
    height: 13vw;
}

.avatar {
    width: 100%;
    height: 100%;
    border-radius: 50%; 
    border: 3px solid #fff; 
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease; 
}

.avatar:hover {
    transform: scale(1.1);
}

.contact-info {
    margin-top: auto;
    margin-bottom: 6em;
    font-size: 1vw;
    padding-left: 2em;
    color: #333;
    line-height: 2;
}

.contact-info strong {
    display: block;
    font-size: 1.5vw;
    margin-bottom: 15px;
}

.email {
    display: flex;
    align-items: center;
    gap: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Contact.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT,oBAAoB;IACpB,aAAa;IACb,gBAAgB;AACpB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,UAAU;EACV,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT;oBACgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,wCAAwC;IACxC,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ","sourcesContent":[".contact-page {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 32px;\n    align-items: stretch; \n    padding: 20px;\n    min-height: 80vh;\n}\n\n.contact-card {\n  display: flex;\n  /* align-items: stretch;  */\n  flex-direction: column;\n  justify-content: space-between;\n  height: 80%;\n  width: 80%;\n  margin: 100px auto 0 auto;              \n  /* padding: px 24px 24px;     */\n  position: relative;\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  text-align: left;\n}\n\n.avatar-wrapper {\n    position: absolute; \n    top: -60px;\n    left: 0px;\n    /* width: 200px;\n    height: 200px; */\n    width: 13vw;\n    height: 13vw;\n}\n\n.avatar {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%; \n    border: 3px solid #fff; \n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    transition: transform 0.3s ease; \n}\n\n.avatar:hover {\n    transform: scale(1.1);\n}\n\n.contact-info {\n    margin-top: auto;\n    margin-bottom: 6em;\n    font-size: 1vw;\n    padding-left: 2em;\n    color: #333;\n    line-height: 2;\n}\n\n.contact-info strong {\n    display: block;\n    font-size: 1.5vw;\n    margin-bottom: 15px;\n}\n\n.email {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
